var exports = {
  "uW": "PurchaseHistorySection.module__section___ZzYzUX",
  "Nr": "PurchaseHistorySection.module__card___ZzYzUX",
  "Vg": "PurchaseHistorySection.module__grid___ZzYzUX",
  "Qs": "PurchaseHistorySection.module__content___ZzYzUX",
  "DD": "PurchaseHistorySection.module__title___ZzYzUX",
  "h_": "PurchaseHistorySection.module__description___ZzYzUX",
  "be": "PurchaseHistorySection.module__accordionStack___ZzYzUX",
  "JC": "PurchaseHistorySection.module__accordion___ZzYzUX",
  "x6": "PurchaseHistorySection.module__button___ZzYzUX",
};

module.exports = exports;
